exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctjzgyB9kZyauJ0sNikid{display:inline-block;position:relative;height:32px;line-height:32px;min-width:52px;font-weight:600;color:\"[theme:themeDark, default:#0D62AA]\";cursor:pointer}html[dir] .ctjzgyB9kZyauJ0sNikid{margin-top:11px;padding:0 4px;text-align:center;background-color:\"[theme:themeLighterAlt, default:#EFF6FC]\";border-radius:2px}html[dir] .ctjzgyB9kZyauJ0sNikid:hover{background-color:\"[theme:themeLighter, default:#DEECF9]\"}html[dir] .ctjzgyB9kZyauJ0sNikid:active{background-color:\"[theme:themeLight, default:#C7E0F4]\"}", ""]);

// exports
exports.locals = {
	"label": "ctjzgyB9kZyauJ0sNikid"
};